import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const INSURER_PAY_COMPENSATION = {
  YES: 'yes',
  NO: 'no',
} as const;

export const INSURER_PAY_COMPENSATION_NAME = 'insurer_pay_compensation';
export const INSURER_PAY_COMPENSATION_NAME_COMPLEMENTARY =
  'insurer_pay_compensation_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupInsurerPayCompensation: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? INSURER_PAY_COMPENSATION_NAME_COMPLEMENTARY
      : INSURER_PAY_COMPENSATION_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy ubezpieczyciel wypłacił odszkodowanie?')}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-insurer-pay-compensation"
            >
              <RadioItem
                value={INSURER_PAY_COMPENSATION.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-insurer-pay-compensation-yes"
              />
              <RadioItem
                value={INSURER_PAY_COMPENSATION.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-insurer-pay-compensation-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
